import axios from "axios";
import { emitUnauthorized } from "./unauthorized-handler";
import { getTenantId } from "../config";
// import { tenants } from "../config";

const options = {
  baseURL: process.env.REACT_APP_API_URL,
  // withCredentials: true,
  timeout: 10000,
};

// const host = new URL(window.location.href)?.host ?? "";

// const tenantID =
//   [
//     ...tenants,
//     {
//       id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//       slug: "phamacore-dev",
//       displayName: "phAMACart Pharmacy",
//       // host: "localhost:3001",
//       clientHost: "localhost:3001",
//       adminHost: null,
//       thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//       companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//     },
//     {
//       id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//       slug: "phamacore-dev",
//       displayName: "phAMACart Pharmacy",
//       // host: "localhost:3000",
//       clientHost: "localhost:3000",
//       adminHost: null,
//       thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//       companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//     },
//   ].find((tenant) => tenant.clientHost === host)?.id ?? "";

// const getTenantId = () => {
//   const host = window.location.host;

//   const rawTenants = [
//     ...JSON.parse(localStorage.getItem("tenants")),
//     {
//       id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//       slug: "phamacore-dev",
//       displayName: "phAMACart Pharmacy",
//       // host: "localhost:3001",
//       clientHost: "localhost:3001",
//       adminHost: null,
//       thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//       companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//     },
//     {
//       id: "142771b0-fa00-4241-a165-e1741dbb3c74",
//       slug: "phamacore-dev",
//       displayName: "phAMACart Pharmacy",
//       // host: "localhost:3000",
//       clientHost: "localhost:3000",
//       adminHost: null,
//       thirdPartyBaseUrl: "https://phamacoredev.co.ke:81",
//       companyProfileId: "74f266e5-a5b9-4cfb-ab7e-828262cb7c92",
//     },
//   ];

//   if (!rawTenants) {
//     return "";
//   }

//   try {
//     const tenants = JSON.parse(rawTenants);

//     return tenants.find((tenant) => tenant.clientHost === host)?.id ?? "";
//   } catch {
//     return "";
//   }
// };

const axiosInstance = axios.create(options);

// content type
axiosInstance.defaults.headers.post["Content-Type"] = "application/json";

axiosInstance.interceptors.request.use(
  (config) => {
    // Always read fresh user data
    const raw = localStorage.getItem("authUser");
    const user = raw ? JSON.parse(raw) : null;

    const token = user?.accessToken;
    // const clientCode = user?.user?.clientCode;

    // 1) Auth header
    // if (token) {
    //   config.headers = config.headers ?? {};
    //   config.headers.Authorization = `Bearer ${token}`;
    // }

    config.headers = config.headers ?? {};

    // SKIP Bearer token for refresh endpoint
    const isRefreshCall = config.url?.includes("/identity/refresh-token");

    if (token && !isRefreshCall) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;

    // Always read fresh user data
    const raw = localStorage.getItem("authUser");
    const user = raw ? JSON.parse(raw) : null;

    // HANDLE 401
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        // queue requests while refreshing
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve,
            reject,
          });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        const refreshToken = user?.refreshToken;
        const oldToken = user?.accessToken;

        const res = await axiosInstance.post(
          "/identity/refresh-token",
          {
            refreshToken,
          },
          {
            headers: {
              Authorization: oldToken,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );

        const resData = res.data;
        const newAccessToken = res.data.accessToken;

        // store new token
        // localStorage.setItem("accessToken", newAccessToken);

        const updatedAuth = {
          ...user,
          accessToken: resData.accessToken,
          refreshToken: resData.refreshToken,
          accessTokenExpiresAtUtc: resData.accessTokenExpiresAtUtc,
        };

        localStorage.setItem("authUser", JSON.stringify(updatedAuth));

        // update default headers
        axiosInstance.defaults.headers.common["Authorization"] =
          `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);

        // retry original request
        originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;

        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);

        emitUnauthorized();

        // // logout user
        // localStorage.removeItem("accessToken");
        // localStorage.removeItem("refreshToken");

        // // optional redirect
        // window.location.href = "/login";

        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    // HANDLE 404 (your existing logic)
    if (status === 404) {
      return Promise.reject(error.response);
    }

    return Promise.reject(error.response);
  },
);

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const status = error?.response?.status;

//     if (status === 401) {
//       // Example: token expired
//       // localStorage.removeItem("authUser");

//       // Optional: redirect
//       // window.location.href = "/logout";
//       try {
//         emitUnauthorized();
//       } catch (e) {
//         // ignore
//       }
//     }

//     if (status === 404) {
//       return Promise.reject(error.response);
//     }
//     // IMPORTANT: pass full error forward
//     return Promise.reject(error.response);
//   },
// );

// Access Key Middleware
axiosInstance.interceptors.request.use(
  (config) => {
    const accessKey = process.env.REACT_API_ACCESS_KEY;

    config.headers = config.headers ?? {};

    if (accessKey) {
      config.headers["accesskey"] = accessKey;
    }

    const tenantID = getTenantId();

    if (tenantID) {
      config.headers["X-Tenant-Id"] = tenantID;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export async function get(url, config = {}) {
  return await axiosInstance.get(url, { ...config }); // interceptor returns data already;
}

export async function post(url, data, config = {}) {
  // return axiosInstance.post(url, { ...data }, { ...config }); // interceptor returns data already;
  const isForm =
    config?.headers?.["Content-Type"] === "application/x-www-form-urlencoded";

  return axiosInstance.post(url, isForm ? data : { ...data }, config);
}

export async function put(url, data, config = {}) {
  return axiosInstance.put(url, { ...data }, { ...config }); // interceptor returns data already;
}

export async function del(url, config = {}) {
  return await axiosInstance.delete(url, { ...config }); // interceptor returns data already;
}

export const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export const isTokenExpired = (expiresAtUtc) => {
  if (!expiresAtUtc) return true;

  return new Date(expiresAtUtc).getTime() <= Date.now();
};
